// extracted by mini-css-extract-plugin
module.exports = {"rowTwice":"BodyRow_rowTwice__3xvjy","btnTs":"BodyRow_btnTs__1fc0R"};